// extracted by mini-css-extract-plugin
export default {"link":"AsideLink_link__ILJ5o","disabled":"AsideLink_disabled__6E7Gd","active":"AsideLink_active__xpbdv"};